export class ApptTotalModel {
    appt_total: number
    appt_resource_date: string
    appt_resource_code: string

    constructor(
        appt_total: number,
        appt_resource_date: string,
        appt_resource_code: string
    ) {
        this.appt_total = appt_total
        this.appt_resource_date = appt_resource_date
        this.appt_resource_code = appt_resource_code
    }
}  

export class ApptCodeTotalModel {
    appt_proc_id: number
    appointment_date: string
    appt_total: number

    constructor(
        appt_proc_id: number,
        appointment_date: string,
        appt_total: number
    ) {
        this.appt_proc_id = appt_proc_id
        this.appointment_date = appointment_date
        this.appt_total = appt_total
    }
}   